export const TG_CHANNEL_LINK = 'https://telegram.me//cian_ir';

export const MAIN_CIAN_LINK = 'https://www.cian.ru';

export const IPOTEKA_PARTNER = 'https://www.cian.ru/ipoteka-partner/?cian_source=header_mortgage';

export const ONLINE_CONTRACT =
  'https://www.cian.ru/novosti-tsian-i-gosuslugi-zapustili-servis-uproschajuschij-oformlenie-dogovorov-arendy-341140/';

export const SMART_DEAL = 'https://smartdeal.pro';

export const PRAVA_SOBSTVENNOSTI = 'https://www.cian.ru/registraciya-prava-sobstvennosti-na-nedvizhimost/';

export const BTN_TECHNOLOGIES_LINK = { text: 'Технологии Циан', url: '/ir-edu/key_technologies' };

export const BTN_CORE_BUSINESS_LINK = { text: 'Основной бизнес', url: '/ir-edu/core_business' };

export const BTN_TRANSACTIONAL_LINK = { text: 'Транзакционный бизнес', url: '/ir-edu/transactional_business' };

export const BTN_DAILY_LINK = { text: 'Посуточная аренда', url: '/ir-edu/posutochno' };

export const MAIN_IR_LINK = 'https://ir.ciangroup.ru/ru/';

export const IR_FIN_RESULT_LINK = 'https://ir.ciangroup.ru/ru/financials/reports-and-presentations/';
